import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 240px;\n  padding: 0;\n  padding-top: 92px;\n  padding-bottom: 100px;\n  border-radius: 0;\n\n  gap: 24px;\n  @media (max-width: 768px) {\n    padding-top: 60px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from "react";
import styled from "styled-components";
import { useRouter } from "next/router";
import { Box, Typography, useTheme } from "@mui/material";
import { Button } from "@bookips/solvook-ui-library";
import { useSideCategoryMenuStore } from "../SideSheets/store/useCategoryMenuStore";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
// 카테고리 메뉴판을 열어주기 위한 카테고리 메뉴 구분자 입니다.
// 서버에서 설정한 아이디 값과 과목을 매칭한 값입니다.
// 현재 국영수를 제외한 과목은 기타 13번으로 내려오는데, 남은 과목별로 세분화 될 가능성이 있어서, 나머지 과목은 13번으로 잡아둡니다.
// 10: 영어, 11: 국어, 12: 수학, 13: 사회/과학/기타
const SubjectCategoryId = {
    EN: 10,
    KO: 11,
    MA: 12,
    SO: 13,
    SC: 13,
    SL: 13,
    KH: 13,
    HI: 13,
    ET: 13,
    ALL: 13
};
export const SearchProductEmpty = (param)=>{
    let {} = param;
    const { query  } = useRouter();
    const theme = useTheme();
    const { q: searchKeyword , subject: subjectCode  } = query;
    const { openSideMenu , openMobileSideMenu , setCurrentDepth  } = useSideCategoryMenuStore();
    const { isTablet  } = useWindowDimensions();
    const handleFindCategoryClick = useCallback(()=>{
        const subjectId = SubjectCategoryId[subjectCode];
        setCurrentDepth(String(subjectId));
        if (isTablet) openMobileSideMenu();
        else openSideMenu();
    }, [
        isTablet,
        setCurrentDepth,
        subjectCode,
        openSideMenu
    ]);
    return /*#__PURE__*/ _jsxs(SearchProductEmptyWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        sx: {
                            color: theme.palette.grey[500]
                        },
                        children: '"'.concat(searchKeyword, '" 의')
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        sx: {
                            color: theme.palette.text.title
                        },
                        children: "검색결과가 없어요."
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                label: "카테고리로 찾아보기",
                variant: "solid",
                size: "large",
                onClick: handleFindCategoryClick
            })
        ]
    });
};
const SearchProductEmptyWrapper = styled.div.withConfig({
    componentId: "sc-f2851e5a-0"
})(_templateObject());
